import { FC, memo } from 'react'
import styles from './index.module.scss'
import { WALLET_TYPE } from '@/constants'
import { WalletType } from '@/services/apis/wallet/models'
import classNames from 'classnames'
import { useTranslation } from '@/services/i18n'
import { LanguageEnum } from '@/services/i18n'

interface WalletBadgeProps {
  type: WalletType
}

const WalletBadge: FC<WalletBadgeProps> = ({ type }) => {
  const { i18n } = useTranslation()
  const style =
    i18n.language === LanguageEnum.EN_US && type !== 2
      ? {
          left: 4,
          top: 3,
        }
      : undefined
  return (
    <div
      className={classNames({
        [styles.badge]: true,
        [styles.web3]: type === 2,
      })}
    >
      <div className={styles.badgeName} style={style}>
        {WALLET_TYPE()[type]}
      </div>
    </div>
  )
}

export default memo(WalletBadge)
